import { render, staticRenderFns } from "./OrderAllowanceCharge.vue?vue&type=template&id=457ad36c&scoped=true&"
import script from "./OrderAllowanceCharge.vue?vue&type=script&lang=ts&"
export * from "./OrderAllowanceCharge.vue?vue&type=script&lang=ts&"
import style0 from "./OrderAllowanceCharge.vue?vue&type=style&index=0&id=457ad36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ad36c",
  null
  
)

export default component.exports